<template>
  <div class="caption individual-rule__wrapper">
    <div class="body-1 font-weight-bold my-2">Example scoring</div>
    <div class="sample-image__wrapper">
      <div style="height: 100%;">
        <img :src="SampleResults" alt="sample-result" style="width: 100%" />
      </div>
    </div>
  </div>
</template>

<script>
import SampleResults from '@/assets/sample-score-2.png'
export default {
  name: 'ExampleRules',
  data: () => ({
    SampleResults
  })
}
</script>
